<template>
  <CurationRenderer
    class="jps-database"
    v-if="dbPage"
    :curation="dbPage"
    :show-edit="showEdit"
    @edit="edit()"
  />
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { langPath } = useI18n()
const route = useRoute()
const router = useRouter()
const dataStore = useDataStore()
const userStore = useUserStore()

const dbPage = computed(() => {
  return dataStore.curation(route.params.dbId + '-db')
})

const db = computed(() => {
  return dataStore.database(route.params.dbId as string)
})

const showEdit = computed(() => {
  return db.value && userStore.hasEditForData(db.value)
})

const edit = () => {
  router.push(langPath(`/management/database/${db.value.id}/page`))
}
</script>

<style lang="scss" scoped></style>
